import ArrowRight from '../../icons/ArrowRight';
import './ToolsDashboard.css'
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import useLanguagePrefix from '../../LanguagePrefix';

function ToolsDashboard() {
    const langPrefix = useLanguagePrefix();
    const { t } = useTranslation();

    return (
        <div>
            <Helmet>

                <title>Free Online Calculators for Hotels, Resorts & Hospitality Operators | Prostay</title>
                <meta name="description" content="Access free online calculators for hotels, resorts, and hospitality operators. Use tools like RevPAR, ADR, Occupancy Rate, and more to make smarter revenue and cost decisions." />
                <link rel="canonical" href={"https://www.prostay.com" + langPrefix + "/tools/"} />

                <link rel="alternate" href="https://www.prostay.com/en/tools/" />
                <link rel="alternate" href="https://www.prostay.com/es/tools/" />

                <meta property="og:title" content="Free Online Calculators for Hotels, Resorts & Hospitality Operators | Prostay" />
                <meta property="og:description" content="Access free online calculators for hotels, resorts, and hospitality operators. Use tools like RevPAR, ADR, Occupancy Rate, and more to make smarter revenue and cost decisions." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={"https://www.prostay.com" + langPrefix + "/tools/"} />
                <meta property="og:image" content='https://prostay.com/images/ogImage.png' />

                <meta property="og:site_name" content="Prostay" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Free Online Calculators for Hotels, Resorts & Hospitality Operators | Prostay" />
                <meta name="twitter:description" content="Access free online calculators for hotels, resorts, and hospitality operators. Use tools like RevPAR, ADR, Occupancy Rate, and more to make smarter revenue and cost decisions." />
                <meta name="twitter:image" content='https://prostay.com/images/ogImage.png' />
                <meta name="twitter:site" content="@prostaypms" />
                <meta name="twitter:creator" content="@prostaypms" />

            </Helmet>
            <div className='tools-dashboard'>
                <div className='d-flex align-items-center flex-column text-center'>
                    <h1 className='mb-3' style={{ maxWidth: '1000px' }}>
                        {t('Free Online calculators for Hotels, Resorts, and Hospitality Operators')}
                    </h1>
                    <h6>
                        {t('Optimize your hotel’s pricing, performance, and forecasting with easy-to-use calculators for ADR, RevPAR, occupancy, and more.')}
                    </h6>
                </div>
                <div className='tools-grid'>
                    <div className='rounded-white-box box d-flex flex-column'>
                        <h5>
                            {t('Average Daily Rate (ADR)')}
                        </h5>
                        <small className='label-xsmall'>
                            {t('Average Daily Rate (ADR) is a core hotel metric used to calculate the average revenue earned per sold room per day.')}
                        </small>
                        <a className='label-xsmall mt-2' href={`${langPrefix}/adr-calculator/`}>
                            {t('View')} &gt;
                        </a>
                    </div>
                    <div className='rounded-white-box box d-flex flex-column'>
                        <h5>
                            {t('RevPAR')}
                        </h5>
                        <small className='label-xsmall'>
                            {t('Revenue per Available Room (RevPAR) shows how effectively your hotel fills rooms at profitable rates.')}
                        </small>
                        <a className='label-xsmall mt-2' href={`${langPrefix}/revpar-calculator/`}>
                            {t('View')} &gt;
                        </a>
                    </div>
                    <div className='rounded-white-box box d-flex flex-column'>
                        <h5>
                            {t('Occupancy Rate')}
                        </h5>
                        <small className='label-xsmall'>
                            {t('Occupancy Rate measures the percentage of available rooms that are sold during a given period.')}
                        </small>
                        <a className='label-xsmall mt-2' href={`${langPrefix}/occupancy-rate/`}>
                            {t('View')} &gt;
                        </a>
                    </div>
                    <div className='rounded-white-box box d-flex flex-column'>
                        <h5>
                            {t('GOPPAR')}
                        </h5>
                        <small className='label-xsmall'>
                            {t('Gross Operating Profit per Available Room (GOPPAR) evaluates how efficiently a hotel converts revenue into profit.')}
                        </small>
                        <a className='label-xsmall mt-2' href={`${langPrefix}/goppar-calculator/`}>
                            {t('View')} &gt;
                        </a>
                    </div>
                    <div className='rounded-white-box box d-flex flex-column'>
                        <h5>
                            {t('TrevPAR')}
                        </h5>
                        <small className='label-xsmall'>
                            {t('Total Revenue per Available Room (TRevPAR) expands on RevPAR by including all revenue sources.')}
                        </small>
                        <a className='label-xsmall mt-2' href={`${langPrefix}/trevpar-calculator/`}>
                            {t('View')} &gt;
                        </a>
                    </div>
                    <div className='rounded-white-box box d-flex flex-column'>
                        <h5>
                            {t('TrevPAB')}
                        </h5>
                        <small className='label-xsmall'>
                            {t('Total Revenue per Available Bed (TRevPAB) measures total income generated per bed rather than per room.')}
                        </small>
                        <a className='label-xsmall mt-2' href={`${langPrefix}/trevpab-calculator/`}>
                            {t('View')} &gt;
                        </a>
                    </div>
                    <div className='rounded-white-box box d-flex flex-column'>
                        <h5>
                            {t('Cost Per Occupied Room')}
                        </h5>
                        <small className='label-xsmall'>
                            {t('Cost Per Occupied Room (CPOR) measures the average cost to service one occupied room.')}
                        </small>
                        <a className='label-xsmall mt-2' href={`${langPrefix}/cpor-calculator/`}>
                            {t('View')} &gt;
                        </a>
                    </div>
                    <div className='rounded-white-box box d-flex flex-column'>
                        <h5>
                            {t('Average Length of Stay')}
                        </h5>
                        <small className='label-xsmall'>
                            {t('The Average Length of Stay (ALOS) measures how many nights guests typically stay at your property.')}
                        </small>
                        <a className='label-xsmall mt-2' href={`${langPrefix}/alos-calculator/`}>
                            {t('View')} &gt;
                        </a>
                    </div>
                </div>
                <div className='rounded-white-box d-flex flex-xl-row flex-column box-width' style={{ boxShadow: '0px 64px 128px #E3E9FC', borderRadius: '8px' }}>
                    <div className='box-padding gap-2 d-flex flex-column'>
                        <h4>
                            {t('Smarter hotel management with Prostay')}
                        </h4>
                        <p>
                            {t('From automated rate management and real-time reporting to integrated POS, smart reservations, and a full suite of financial calculators — Prostay gives you the tools to run your hotel more efficiently.')}
                        </p>
                        <p>
                            {t('Whether you’re managing a boutique resort or a multi-property operation, our platform is designed to simplify your workflow, reduce manual tasks, and boost profitability through intelligent automation.')}
                        </p>
                        <div className='active-button'>
                            <a className='light-blue-filled-btn-xsmall' style={{ height: '38px', width: '124px', color: '#fff' }} href={`${langPrefix}/property-management-system/`}>
                                {t('Learn More')}
                                <ArrowRight />
                            </a>
                        </div>

                    </div>
                    <div className='box-padding'>
                        <img src='/images/tools-dashboard.svg' alt='Property Management System analytics' />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ToolsDashboard;